import { GRANULARITY } from '../contexts/FatigueEvolutionContext'
import { getDDMM, getDDMMYY, getMMYY } from './dateConversion'

const GRANULARITIES = {
  [GRANULARITY.DAILY]: ({ periodEnd }) => {
    return `${getDDMM({ date: periodEnd })}`
  },
  [GRANULARITY.WEEKLY]: ({ periodStart, periodEnd }) => {
    const diffYear = periodStart.getFullYear() !== periodEnd.getFullYear()

    if (diffYear) {
      return `${getDDMMYY({ date: periodStart })}`
    }

    return `${getDDMM({ date: periodStart })}`
  },
  [GRANULARITY.MONTHLY]: ({ periodEnd }) => {
    return getMMYY({ date: periodEnd })
  },
  [GRANULARITY.ANNUALLY]: ({ label, periodEnd }) => {
    if (label === 'total') {
      return 'Total'
    }

    return periodEnd.getFullYear()
  },
}

export const getFormattedDateByGranularity = ({ periods, granularity }) => {
  if (periods?.length <= 0) return null

  return periods.map(({ start_period, end_period, label }) => {
    const periodStart = new Date(start_period)
    const periodEnd = new Date(end_period)

    const granularityFunction = GRANULARITIES[granularity]
    return granularityFunction?.({ periodStart, periodEnd, label })
  })
}
